export const API_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://souknati-production.up.railway.app/api'
    : 'http://localhost:3001/api');
